import * as React from "react";
import { Accordion } from "../../../../../../../react-core/Html/Accordion";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { PensionProtectionDetails } from "../../../../../../../Wrap/Models/Models/Customer/PensionProtection/PensionProtectionDetails";
import { ITypographySectionProps, Typography } from "../../../../../../Shared/Typography/Typography";
import { GrantedTypes, GrantedTypesMap, PensionProtectionMap } from "../../../ClientRecord/Resource/Contents";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { CustomerPensionProtectionModel } from "../../../../../../../Wrap/Models/Domains/Drawdown/CustomerPensionProtectionModel";

interface IPensionProtectionPlayBackProps {
    data: CustomerPensionProtectionModel;
    hasPensionProtection: boolean;
}
export const PensionProtectionPlayBack = (props: IPensionProtectionPlayBackProps) => {
    let config: ITypographySectionProps[] = [];
    if (!props.data) {return null;}

    const grantSelected = (key: string): string => {
        const _data = props.data[key];
        let flag = null;
        GrantedTypes.forEach((ele) => {
            if (_data[ele]) {flag = ele;}
        });
        return flag;
    };
    PensionProtectionMap.forEach((ele) => {
        if (props.data[ele.key]) {
            if (ele.value.toLowerCase() != "no") {
                config.push({
                    title: <b>{ele.value}</b>,
                    data: props.data[ele.key].HasProtection ? "Yes" : "No",
                });
            }

            switch (ele.key) {
                case "PensionEnhancedProtectionDetails":
                    config = config.concat([
                        { title: "PCLS entitlement (%)", data: props.data[ele.key].PclsEntitlement },
                        { title: "Certificate number", data: props.data[ele.key].CertificateNumber },
                    ]);
                    break;
                case "PensionPrimaryProtectionDetails":
                    config = config.concat([
                        { title: "PCLS entitlement (£)", data: props.data[ele.key].PclsEntitlement },
                        { title: "Certificate number", data: props.data[ele.key].CertificateNumber },
                        { title: "Enhancement factor number", data: props.data[ele.key].EnhancementFactor },
                    ]);
                    break;
                case "PensionFixedProtectionDetails":
                    config = config.concat([
                        {
                            title: "Certificate number (Fixed protection 2012)",
                            data: props.data[ele.key].CertificateNumber,
                        },
                    ]);
                    break;
                case "PensionFixed2014ProtectionDetails":
                    config = config.concat([
                        {
                            title: "Certificate number (Fixed protection 2014)",
                            data: props.data[ele.key].CertificateNumber,
                        },
                    ]);
                    break;
                case "PensionFixed2016ProtectionDetails":
                    config = config.concat([
                        {
                            title: "Certificate number (Fixed protection 2016)",
                            data: props.data[ele.key].CertificateNumber,
                        },
                    ]);
                    break;
                case "PensionIndividual2014ProtectionDetails":
                    config = config.concat([
                        {
                            title: "Certificate number (Individual protection 2014)",
                            data: props.data[ele.key].CertificateNumber,
                        },
                        { title: "Individual Protection 2014 LTA amount", data: props.data[ele.key].Amount },
                    ]);
                    break;
                case "PensionIndividual2016ProtectionDetails":
                    config = config.concat([
                        {
                            title: "Certificate number (Individual protection 2016)",
                            data: props.data[ele.key].CertificateNumber,
                        },
                        { title: "Individual Protection 2016 LTA amount", data: props.data[ele.key].Amount },
                    ]);
                    break;
                case "PensionRelevantOverseasProtectionDetails":
                case "PensionQropsProtectionDetails":
                case "PensionCreditProtectionDetails":
                    config = config.concat([
                        { title: "Certificate number", data: props.data[ele.key].CertificateNumber },
                        { title: "Enhancement factor number", data: props.data[ele.key].EnhancementFactor },
                        { title: "Granted", data: GrantedTypesMap[grantSelected(ele.key)] },
                    ]);
                    break;
                case "PensionSchemeSpecificProtectionDetails":
                case "PensionSchemeSpecificProtection":
                    config = config.concat([
                        { title: "Protected PCLS value", data: props.data[ele.key].PCLSEntitlement },
                        { title: "ADay fund value", data: props.data[ele.key].ADayFundValue },
                        { title: "Protected retirement age", data: props.data[ele.key].ProtectedRetirementAge },
                    ]);
                    break;
                case "Enhanced":
                    config = config.concat([
                        { title: "PCLS entitlement (%)", data: props.data[ele.key].EntitlementPercentage },
                        { title: "Certificate number", data: props.data[ele.key].CertificateNumber },
                    ]);
                    break;
                case "Primary":
                    config = config.concat([
                        { title: "PCLS entitlement (£)", data: props.data[ele.key].ProtectionAmount },
                        { title: "Certificate number", data: props.data[ele.key].CertificateNumber },
                        { title: "Enhancement factor number", data: props.data[ele.key].EnhancementFactor },
                    ]);
                    break;
                case "Individual":
                    props.data[ele.key].forEach((x) => {
                        config.push({
                            title: "Is this client entitled to individual protection " + x.Year + "?",
                            data: "Yes",
                        });
                        config = config.concat([
                            {
                                title: "Certificate number (Individual protection " + x.Year + ")",
                                data: x.CertificateNumber,
                            },
                            { title: "Individual Protection " + x.Year + " LTA amount", data: x.Entitlement },
                        ]);
                    });

                    break;
                case "Fixed":
                    props.data[ele.key].forEach((x) => {
                        config.push({
                            title: "Is this client entitled to fixed protection " + x.Year + "?",
                            data: "Yes",
                        });
                        config = config.concat([
                            {
                                title: "Certificate number (Fixed protection " + x.Year + ")",
                                data: x.CertificateNumber,
                            },
                        ]);
                    });

                    break;
                case "LifetimeAllowanceEnhancements":
                    props.data[ele.key].forEach((x) => {
                        let type = "";
                        let granted = "";
                        let typeTitle = "";
                        if ((x.Type == 1)) {
                            type = "Overseas Individual";
                            typeTitle =
                                "Is this client entitled to a lifetime allowance enhancement factor arising from being a relevant overseas individual?";
                        } else if ((x.Type == 2)) {
                            type = "Overseas Pension Scheme";
                            typeTitle =
                                "Is this client entitled to a lifetime allowance enhancement factor following a transfer from a recognised overseas pension scheme?";
                        } else if ((x.Type == 3)) {
                            type = "Receipt Of Pension Credit";
                            typeTitle =
                                "Is this client entitled to a lifetime allowance enhancement factor following receipt of a pension credit?";
                        }
                        if (x.GrantedPrior2012) {
                            granted = GrantedTypesMap.IsPre6Apr2012;
                        }
                        if (x.GrantedPrior2014) {
                            granted = GrantedTypesMap.IsPre6Apr2014;
                        }
                        if (x.GrantedPrior2016) {
                            granted = GrantedTypesMap.IsPre6Apr2016;
                        }
                        if (x.GrantedPost2016) {
                            granted = GrantedTypesMap.IsPost6Apr2016;
                        }
                        config.push({
                            title: <b>{typeTitle}</b>,
                            data: "Yes",
                        });
                        config = config.concat([
                            { title: "Certificate number (" + type + ")", data: x.CertificateNumber },
                            { title: "Enhancement factor number", data: x.EnhancementFactor },
                            { title: "Granted", data: granted },
                        ]);
                    });

                    break;
                default:
                    break;
            }
        }
    });
    return (
        <>
            <RadiosEditor
                label="Does your client have any form of pension protection?"
                onChange={(v) => {}}
                getText={(o) => (o ? "Yes" : "No")}
                options={[true, false]}
                cssWrapper="rg-inline mb-20"
                disabled={true}
                selected={props.hasPensionProtection ?? false}
            />

            {props.hasPensionProtection ? (
                <Accordion label="Pension protection details" cssWrapper="accordion-with-arrow mb-20">
                    <Typography config={config} colNum={1} type={"wider"} />
                </Accordion>
            ) : (
                <Alert
                    alertType={AlertType.Warning}
                    message={"Your client currently has no pension protection associated with this account."}
                />
            )}
        </>
    );
};
